/**
 * The service item statuses, as the API's `status` filter takes them.
 *
 * @typedef {"AC"|"IN"} ServiceItemStatusCode
 */
/** @type {{code: ServiceItemStatusCode}[]} */
export const SERVICE_ITEM_STATUSES = [{code: "AC"}, {code: "IN"}];

/** What the service items list shows to begin with: only the active ones. */
export const DEFAULT_ITEM_STATUS_FILTER = /** @type {ServiceItemStatusCode[]} */ (["AC"]);

// The service item API returns the raw status code, not the display text.
const ITEM_STATUS_LABELS = {AC: "Ativo", IN: "Inativo"};

/** @param {string} status */
export const itemStatusLabel = (status) => ITEM_STATUS_LABELS[status] ?? status;
